<div fxLayout="row" fxLayoutAlign="space-between" class="border-bottom">
	<h3 class="arc-h3 margin-20" id="search-results" matDialogTitle>Search Results</h3>
	<div class="text-right">
		<app-close-mat-dialog (closeDialog)="cancel()"></app-close-mat-dialog>
	</div>
</div>

<div mat-dialog-content class="border-bottom">
	<mat-card appearance="outlined">
		<mat-expansion-panel *ngIf="retained && data.oldCharges" class="margin-bottom-10">
			<mat-expansion-panel-header>
				<div class="arc-h5">Retained Results&nbsp;({{ retained.length }})</div>
			</mat-expansion-panel-header>
			<app-shared-systemic-search-cases-table [systemicCaseCharges]="retained"></app-shared-systemic-search-cases-table>
		</mat-expansion-panel>
		<mat-expansion-panel *ngIf="removed && data.oldCharges" class="margin-bottom-10">
			<mat-expansion-panel-header>
				<div class="arc-h5">Removed Results&nbsp;({{ removed.length }})</div>
			</mat-expansion-panel-header>
			<app-shared-systemic-search-cases-table [systemicCaseCharges]="removed"></app-shared-systemic-search-cases-table>
		</mat-expansion-panel>
		<mat-expansion-panel class="margin-bottom-10">
			<mat-expansion-panel-header *ngIf="added">
				<div class="arc-h5">Added Results&nbsp;({{ added.length }})</div>
			</mat-expansion-panel-header>
			<app-shared-systemic-search-cases-table [systemicCaseCharges]="added"></app-shared-systemic-search-cases-table>
		</mat-expansion-panel>
	</mat-card>
</div>

<mat-card appearance="outlined" fxLayout="row wrap" fxLayoutAlign="space-between" class="padding-10">
	<div class="margin-top-10 margin-left-10">
		<button type="button" mat-button color="primary" appDebounceClick (debounceClick)="cancel()">Back to Modify Case</button>
	</div>
	<div class="margin-10 button-row pull-text-right">
		<button type="submit" mat-flat-button color="primary" id="sh-ed-sys-src-cs-apply-btn" appDebounceClick (debounceClick)="apply()">
			Apply Watch Case
		</button>
	</div>
</mat-card>
